import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, AlertController, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { AppConfig } from "../../providers/config";
import { PatientProvider } from '../../providers/patient/patient';
import { ClinicProvider } from '../../providers/clinic/clinic';
import { Observable, pipe, Subject } from 'rxjs';
import {map} from 'rxjs/operators/map';
import { DatabaseProvider } from '../../providers/database/database';
import _ from "lodash";
import { AngularFireUploadTask, AngularFireStorage } from "angularfire2/storage";
import { ImageProvider } from "../../providers/image/image";
import * as mime from 'mime-types';
import { Subscription } from 'rxjs/Subscription';
import { PatientsPage } from '../patients/patients';
import { DoctorProvider } from '../../providers/doctor/doctor';

@IonicPage()
@Component({
  selector: 'page-patient-add-edit',
  templateUrl: 'patient-add-edit.html',
})
export class PatientAddEditPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  @ViewChild('formDirective') private formDirective: NgForm;

  program_id: string;
  program_name: string;
  user: any;
  provinces = AppConfig.Global.provinces;

  page_name: string;
  patient_id: string;
  patient: any;
  existing = false;
  clinics: any[] = [];
  doctors: any;
  therapy: string;
  therapies: any[] = [];
  doses: any[] = [];
  indications: any[] = [];
  ncms: any[] = [];
  rcms: any[] = [];
  pharmacies: any[] = [];
  patient_id_prefix: string;
  filteredClinics$: Observable<any[]>;
  selectedClinic: any;
  loading_uniquenumber = false;
  isLoading = false;

  clinicSub: Subscription;
  therapySub: Subscription;
  userSub: Subscription;
  docSub: Subscription;
  patientSub: Subscription;

  task: AngularFireUploadTask;

  snapshot: Observable<any>;
  progress: any;
  complete: any;
  loading_enrolment = false;
  enrolment_url: string;
  enrolment_doc_id: string;
  enrolment_doc: any;
  addeditForm: FormGroup; 

  doc: any;
  inst: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private auth: AuthProvider,
    private dbProvider: PatientProvider,
    private clinicProvider: ClinicProvider,
    private db: DatabaseProvider,
    private fb: FormBuilder,
    public storage: AngularFireStorage,
    private image: ImageProvider,
    private dbDoctor: DoctorProvider
    ) {
    this.init();
    if (this.navParams.get('urldata'))  {
      const existingdoc = this.navParams.get('urldata');
      console.log('Doc: ', existingdoc);
      this.enrolment_doc = existingdoc;
      this.enrolment_url = existingdoc.enrolment_doc_url;
      this.enrolment_doc_id = existingdoc.enrolment_doc_id;
      this.addeditForm.controls['enrolment_received'].setValue(new Date());
    }
  }

  async getUserClinics()  {
    return new Promise((resolve, reject) => {
      this.auth.getCurrentUser().then(async user => {
        this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
        this.program_name = user.program_name;
        this.program_id = user.program_id;
  
        this.clinicSub = this.clinicProvider
        .listClinics(this.program_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        })
        .takeUntil(this.ngUnsubscribe)
        .subscribe((clinics) => {
          // console.log('Clinics: ', clinics);
          this.clinics = clinics;
          resolve();
        });

        this.db
        .getPharmaciesByProgram(this.program_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        })
        .takeUntil(this.ngUnsubscribe)
        .subscribe((pharmacies) => {
          // console.log('Clinics: ', clinics);
          this.pharmacies = pharmacies;
          resolve();
        });
      });
    });
  }

  ngOnDestroy() {
    console.log('Leaving add - edit patient view and destroying subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  async getTherapies()  {
    return new Promise((resolve, reject) => {
      this.therapySub = this.db
      .getTherapyByProgram(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((therapies) => {
        // console.log('Therapies: ', therapies);
        this.therapies = therapies;
        resolve();
      });
    });
  }

  ionViewWillLeave() {
    console.log('leaving');
    setTimeout(() => {
      this.clinics = [];
      if(this.patientSub) {
        this.patientSub.unsubscribe();
      }
      this.clinicSub.unsubscribe();
      this.therapySub.unsubscribe();
      this.userSub.unsubscribe();
      if(this.docSub) {
        this.docSub.unsubscribe();
      }
      this.formDirective.resetForm();
      this.addeditForm.reset();
    }, 0);
  }

  
  async init()  {
    await this.createForm();
    const loader = this.loadingCtrl.create({});
    loader.present().then(async () => {
      
      await this.getUserClinics();
      await this.getTherapies();
      await this.getNRCMs();
  
      if (this.navParams.get('patient_id')) {
        this.existing = true;
        this.patient_id = this.navParams.get('patient_id');
        this.patient = await this.getPatient();
        console.log('Patient: ', this.patient);
        this.page_name = 'Edit ' + this.patient.first_name + ' ' + this.patient.last_name;
        if (this.patient.doctor) {
          this.doc = this.patient.doctor;
        }
        if (this.patient.clinic) {
          this.inst =  this.patient.clinic;
        }
        if (this.patient.dob) {
          console.log('DOB Date: ', this.patient.dob);
          this.patient.dob = new Date(this.patient.dob.seconds * 1000);
        }
        if (this.patient.enrolment_received) {
          console.log('Enrolment Date: ', this.patient.enrolment_received);
          this.patient.enrolment_received = new Date(this.patient.enrolment_received.seconds * 1000);
        }
        if (this.patient.diagnosis_date) {
          console.log('Diagnosis Date: ', this.patient.diagnosis_date);
          this.patient.diagnosis_date = new Date(this.patient.diagnosis_date.seconds * 1000);
        }
        if (this.patient.therapy) {
          await this.onTherapyChange(this.patient.therapy);
        }
        if (this.patient.clinic) {
          await this.onInstitutionChange(this.patient.clinic.id);
        }
        this.addeditForm.patchValue(this.patient);
        if (this.patient.enrolment_url) {
          this.enrolment_url = this.patient.enrolment_url;
        }        
  
      } else {
        this.patient = null;
        this.page_name = 'Add Patient';
        this.existing = false;
      }
      
      // this.filteredClinics$ = this.addeditForm.controls['clinic'].valueChanges.pipe(
      //   startWith(''),
      //   map(clinic => {
      //     if(clinic) return typeof clinic === 'string' ? clinic : clinic.name
      //     else return null;
      //   }),
      //   map(name => name ? this.filterClinics(name) : this.clinics.slice())
      // );

      // this.addeditForm
      //   .controls['doctor']
      //   .valueChanges
      //   .pipe(
      //     debounceTime(300),
      //     tap(() => this.isLoading = true),
      //     switchMap(value => this.dbDoctor.searchDoctors(this.program_id, value).snapshotChanges())
      //   )
      //   .subscribe((doctors) => {
      //     console.log('Doctors: ', doctors);
      //     this.doctors = doctors;
      //     this.isLoading = false
      //   })

      // .subscribe(users => this.filteredUsers = users.results);
      loader.dismiss();
    });
  }

  async getPatient()  {
    console.log('Params: ', this.program_id, this.patient_id);
    return new Promise((resolve, reject) => {
      this.patientSub = this.dbProvider
      .getPatient(this.program_id, this.patient_id)
      .snapshotChanges()
      .pipe(map(changes => {
        const data: any = changes.payload.data();
        const id = changes.payload.id;
        return { id, ...data };
      }))
      .takeUntil(this.ngUnsubscribe)
      .subscribe((patient) => {
        patient['id'] = this.patient_id;
        resolve(patient);
      });  
    });
  }

  async getNRCMs()  {
    return new Promise((resolve, reject) => {
      this.userSub = this.db
      .getUsers()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((users) => {
        this.ncms = _.filter(users, user => user.roles.navigator_ncm);
        this.rcms = _.filter(users, user => user.roles.navigator_rcm);
        resolve();
      });  
    });
  }


  public objectComparisonFunction = function( option, value ) : boolean {
    if(option && value) return option.id === value.id;
    else return null;
  }

  displayDocFn(clinic?: any): string | undefined {
    return clinic ? clinic.name : undefined;
  }

  setValue()  {
    this.addeditForm.controls['clinic'].setValue('');
  }

  filterClinics(name: string) {
    return this.clinics.filter(clinic => clinic.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  checkDoc(doc) {
    console.log('Doc: ', doc)
    return false;
  }

  async createForm()  {
    return new Promise((resolve, reject) => {
      let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let phoneregex: RegExp = /^\+[1-9]\d{1,14}(\se?x?t?(\d*))?$/
      let cellfaxregex: RegExp = /^\+[1-9]\d{1,14}$/

      this.addeditForm = this.fb.group({
        'first_name': [null, [Validators.required]],
        'middle_name': [null],
        'last_name': [null, [Validators.required]],
        'gender': [null],
        'dob': [null],
        'language': [null],
        'healthcard': [null],
        'height': [null],
        'weight': [null],
        'work_number': [null, [Validators.pattern(phoneregex)]],
        'phone_number': [null, [Validators.pattern(phoneregex)]],
        'cell_number': [null, [Validators.pattern(cellfaxregex)]],
        'email': [null, [Validators.pattern(emailregex)]],
        'voicemail_consent': [null],
        'contact_time': [null],
        'address': [null],
        'address2': [null],
        'city': [null],
        'province': [null],
        'postal_code': [null],
        'address_shipping': [null],
        'address2_shipping': [null],
        'city_shipping': [null],
        'province_shipping': [null],
        'postal_code_shipping': [null],
        'alt_contact_desc': [null],
        'alt_contact_name': [null],
        'alt_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
        'alt_contact_work_number': [null, [Validators.pattern(phoneregex)]],
        'alt_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
        'alt_contact_email': [null, [Validators.pattern(emailregex)]],
        'alt_contact_consent': [null],
        'therapy': [null],
        'indication': [null],
        'dose': [null],
        'program_patient_id': [null],
        'diagnosis_date': [null],
        'enrolment_received': [null, [Validators.required]],
        'doctor': [null],
        'pharmacy': [null],
        'ncm': [null],
        'rcm': [null],
        'notes': [null],
        'transfer': [null]
      });
      this.addeditForm.controls['transfer'].setValue('No');
      resolve();
    });
  }

  save() {
    let patient = this.addeditForm.value;
    if(!patient.enrolment_received_createdBy) {
      patient.enrolment_received_createdBy = this.user.name;
      patient.enrolment_received_createdById = this.user.id,
      patient.enrolment_received_createdAt = new Date()
    }
    patient = { 
      clinic: this.inst ? this.inst : null,
      clinic_id: this.inst ? this.inst.id : null,
      clinic_name: this.inst ? this.inst.name : null,
      program_institution_id: this.inst ? this.inst.program_institution_id : null,
      doctor_id: this.doc ? this.doc.id : null,
      doctor_name: this.doc ? this.doc.first_name + ' ' + this.doc.last_name : null,
      program_physician_id: this.doc ? this.doc.program_physician_id : null,
      enrolment_url: this.enrolment_url ? this.enrolment_url : null,
      ...patient
    }
    console.log('Patient before save: ', patient, this.doc, this.inst);
    if (this.existing) {
      this.dbProvider.updatePatient(this.program_id, this.patient.id, patient, this.user, this.enrolment_doc)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    } else {
      patient = { status: 'Pending Enrolment', substatus: null, ...patient };
      this.dbProvider.addPatient(this.program_id, patient, this.user, this.enrolment_doc)
      .then(() => {
        this.navCtrl.setRoot(PatientsPage);
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    }
  }

  public async onTherapyChange(name)  {
    return new Promise((resolve, reject) => {
      if(name)  {
        name = name.trim()
        this.therapy = name;
        const therapy = this.therapies.filter(item => item.name === name);
        if(therapy.length > 0) {
          this.indications = therapy[0]['indications'];
          this.patient_id_prefix = therapy[0]['prefix'];
          this.doses = therapy[0]['dosing'];
        }
      } else {
        this.patient_id_prefix = null;
        this.indications = [];
        this.doses = [];
      }
      this.addeditForm.controls['program_patient_id'].setValue(null);
      resolve();
    });
  }

  public async onInstitutionChange(id)  {
    return new Promise((resolve, reject) => {
      this.docSub = this.dbProvider
      .listDoctorsByClinic(this.program_id, id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((doctors) => {
        // console.log('Doctors: ', doctors);
        this.doctors = doctors;
        resolve();
      });
    });
  }

  public handleChange($event: KeyboardEvent) {
    const searchTerm = (($event.target as HTMLInputElement).value);
    this.isLoading = true;
    if (searchTerm.length > 1)  {
      console.log('Search for: ', searchTerm);
      this.dbDoctor.searchDoctors(this.program_id, searchTerm)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(doctors => {
        this.doctors = doctors;
        this.isLoading = false;
      });
    }
  }

  getDoctorInstitution(event) {
    this.doc = { ...event.source.value };
    if (event.source.value['program/' + this.program_id + '/clinics'])  {
      this.inst = { ...event.source.value['program/' + this.program_id + '/clinics'][0] };
    } else {
      this.inst = null;
    }
    delete this.doc['program/' + this.program_id + '/clinics'];
    console.log('Selected doc and inst: ', this.doc, this.inst);
  }

  displayFn(doctor?: any): string | undefined {
    return doctor ? doctor.last_name + ', ' + doctor.first_name : undefined;
  }

  generateProgramId()  {
    if (!this.therapy)  {
      let confirm = this.alertCtrl.create({
        title: "Generate ID",
        message: "You must first select a therapy before generating a patient ID",
        buttons: [
          {
            text: "OK",
            handler: () => {}
          }
        ]});
        confirm.present();
    } else {
      this.loading_uniquenumber = true;
        this.dbProvider.getNextPatientId(this.program_id, this.therapy).then(eisaiId => {
          this.addeditForm.controls['program_patient_id'].setValue(eisaiId);
          this.loading_uniquenumber = false;
        })
        .catch((err) => {
          this.loading_uniquenumber = false;
        })
    }
  }

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  // ************* File Upload ****************
  async createUploadTask(file: any) {
    return new Promise((resolve, reject) => {
     
      let filePath: any = null;
      filePath = `documents/${new Date().getTime()}_${file.name}.${file.ext}`;

      // console.log("File Path: ", filePath);
      this.task = this.storage.ref(filePath).putString(file['b64'], "data_url")
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          file['url'] = u;
          file['doc_type'] = 'Enrolment'
          this.enrolment_doc = { enrolment_doc_url: u, enrolmentment_doc_id: null };
          this.enrolment_url = u;
          this.enrolment_doc_id = null;
          // console.log("File Upload Complete: ", this.patient, file); 
          resolve(true);
        })
      });
      this.snapshot = this.task.snapshotChanges();
      this.progress = this.task.percentageChanges();
    });
  }

  public uploadDesktopFiles(fileInputEvent: any) {
    const files = fileInputEvent.target.files;
    this.loading_enrolment = true;
    this.processFiles(Array.from(files)).then((uploads) => {
      setTimeout(() => {
        // console.log('pre loop: ', uploads, uploads.length);
        const start = async () => {
          await this.asyncForEach(uploads, async (file) => {
            await this.createUploadTask(file);
          });
          this.loading_enrolment = false;
        }
        start();
      }, 500);
    });
  }

  async processFiles(files) {
    let i = [];
    await files.reduce(async (promise, file) => {
      await promise;
      this.image.getBase64(file).then((image) => {
        let filename = file.name;
        let name: any = file.name.split('.')[0].replace(' ','');
        let fileext: any = file.name.split('.')[1].replace(' ','');
        let mimetype: any = mime.lookup(fileext);
        // console.log('File: ', filename, name, fileext, mimetype)
        i.push({ filename: filename, name: name, b64: image, ext: fileext, mimetype: mimetype });
      });
    }, Promise.resolve());
    return i;
  }

  isActive(snapshot) {
    return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }

  viewPDF() {
    window.open(this.enrolment_url, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/pages/patient-add-edit/patient-add-edit.ts